export default __webpack_public_path__ + "static/media/emp2.44e9cdd9.png";